import React from 'react';
import Pagination from 'react-bootstrap/Pagination'
import PageItem from 'react-bootstrap/PageItem'

export default class PaginationView extends React.Component {
	render() {
		const {pagingEventHandler, pagination} =  this.props;
		return (
			pagination.last_page > 1  &&
			<div className="paginationPanel">
			<span className="paginationItemsPanel"> 
			<Pagination>
				<Pagination.First onClick={() => pagingEventHandler(1)} key="first" data-val="1" disabled={1 == pagination.current_page}/>
				<Pagination.Prev onClick={() => pagingEventHandler(1)}  key="prev" data-val={pagination.current_page-1} disabled={1 == pagination.current_page}/>
				<Pagination.Next onClick={() => pagingEventHandler(pagination.current_page+1)} key="next" value="last" data-val={pagination.current_page+1} disabled={pagination.last_page == pagination.current_page}/>
				<Pagination.Last key="last" value="last" data-val={pagination.last_page} onClick={() => pagingEventHandler(pagination.last_page)} disabled={pagination.last_page == pagination.current_page}/>		
			</Pagination>
			</span>
			<span className="pageInfoPanel">
				<label className="currentPage">{pagination.current_page}</label>
				&nbsp;van&nbsp;
				<label className="totalPages">{pagination.last_page}</label>
				&nbsp;Pagina's
			</span>
			</div>
		);	
	}	
}